import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BookAppointmentState {
  currentStep: number;
  healthFaciltyStep: number;
  manualFacilityStep: number;
  authFacility: number;
  summaryStep: number;
  selectedService: string | null;
  serviceType: string | null;
  serviceOffering: string | null;
  serviceOfferingOption: string | null;
  homeAddress: string | null;
  closestBusStop: string | null;
  prefferedLocation: "health facility" | "home" | null;
  healthFacilityOption: "auto" | "manual" | null;
  healthFacilityLocationManualState: string | null;
  healthFacilityLocationManualLGA: string | null;
  accessPointId: string | null;
  personelIds: string[] | null;
  selctedPaymentType: string | null;
}

const initialState: BookAppointmentState = {
  currentStep: 1,
  healthFaciltyStep: 1,
  manualFacilityStep: 1,
  authFacility: 1,
  summaryStep: 1,
  homeAddress: null,
  closestBusStop: null,
  selectedService: null,
  serviceType: null,
  serviceOffering: null,
  serviceOfferingOption: null,
  prefferedLocation: null,
  healthFacilityOption: null,
  healthFacilityLocationManualState: null,
  healthFacilityLocationManualLGA: null,
  accessPointId: null,
  personelIds: [],
  selctedPaymentType: null,
};

const bookAppointmentSlice = createSlice({
  name: "bookAppointment",
  initialState,
  reducers: {
    setSelectedService(state, action: PayloadAction<string>) {
      state.selectedService = action.payload;
    },
    setServiceType(state, action: PayloadAction<string>) {
      state.serviceType = action.payload;
    },
    setServiceOffering(state, action: PayloadAction<string>) {
      state.serviceOffering = action.payload;
    },
    setServiceOfferingOption(state, action: PayloadAction<string>) {
      state.serviceOfferingOption = action.payload;
    },
    setPrefferedLocation(
      state,
      action: PayloadAction<"health facility" | "home">
    ) {
      state.prefferedLocation = action.payload;
    },
    setHealthFacilityOption(state, action: PayloadAction<"auto" | "manual">) {
      state.healthFacilityOption = action.payload;
    },
    setHealthFacilityLocationManualState(state, action: PayloadAction<string>) {
      state.healthFacilityLocationManualState = action.payload;
    },
    setHealthFacilityLocationManualLGA(state, action: PayloadAction<string>) {
      state.healthFacilityLocationManualLGA = action.payload;
    },
    setAccessPointId(state, action: PayloadAction<string>) {
      state.accessPointId = action.payload;
    },
    setPersonelIds(state, action: PayloadAction<string[]>) {
      state.personelIds = action.payload;
    },
    nextStep(state) {
      state.currentStep += 1;
    },
    previousStep(state) {
      if (state.currentStep > 1) {
        state.currentStep -= 1;
      }
    },
    nextHealthFacilityStep(state) {
      state.healthFaciltyStep += 1;
    },
    previousHealthFacilityStep(state) {
      if (state.healthFaciltyStep > 1) {
        state.healthFaciltyStep -= 1;
      }
    },
    nextHealthFacilityManualStep(state) {
      state.manualFacilityStep += 1;
    },
    previousHealthFacilityManualStep(state) {
      if (state.manualFacilityStep > 1) {
        state.manualFacilityStep -= 1;
      }
    },
    nextSummaryStep(state) {
      state.summaryStep += 1;
    },
    previousSummaryStep(state) {
      if (state.summaryStep > 1) {
        state.summaryStep -= 1;
      }
    },
    setHomeAddress(state, action: PayloadAction<string>) {
      state.homeAddress = action.payload;
    },
    setClosestBusStop(state, action: PayloadAction<string>) {
      state.closestBusStop = action.payload;
    },
    setSelctedPaymentType(state, action: PayloadAction<string>) {
      state.selctedPaymentType = action.payload;
    },

    nextAuthFacility(state) {
      state.authFacility += 1;
    },

    previousAuthFacility(state) {
      if (state.authFacility > 1) {
        state.authFacility -= 1;
      }
    },

    resetAppointmentFlow(state) {
      state.currentStep = 1;
      state.selectedService = null;
      state.serviceType = null;
      state.serviceOffering = null;
      state.serviceOfferingOption = null;
      state.prefferedLocation = null;
      state.healthFacilityOption = null;
      state.healthFacilityLocationManualState = null;
      state.healthFacilityLocationManualLGA = null;
      state.accessPointId = null;
      state.healthFaciltyStep = 1;
      state.manualFacilityStep = 1;
      state.personelIds = null;
      state.authFacility = 1;
      state.summaryStep = 1;
      state.homeAddress = null;
      state.closestBusStop = null;
      state.selctedPaymentType = null;
    },
  },
});

export const {
  setSelectedService,
  setServiceType,
  setServiceOffering,
  setServiceOfferingOption,
  setPrefferedLocation,
  setHealthFacilityOption,
  setPersonelIds,
  nextStep,
  previousStep,
  nextHealthFacilityStep,
  previousHealthFacilityStep,
  setHealthFacilityLocationManualState,
  setHealthFacilityLocationManualLGA,
  setAccessPointId,
  nextHealthFacilityManualStep,
  previousHealthFacilityManualStep,
  resetAppointmentFlow,
  nextAuthFacility,
  previousAuthFacility,
  setHomeAddress,
  setClosestBusStop,
  nextSummaryStep,
  previousSummaryStep,
  setSelctedPaymentType,
} = bookAppointmentSlice.actions;

export default bookAppointmentSlice.reducer;
